import { memoize } from "lodash";
import { computed, observable, runInAction } from "mobx";
import {
  apiCallReassignKhattabaAll,
  apiCallReassignKhattabaOne
} from "../../api/khattbat-api/api-call-reassign-khattaba";
import { TEt3PickerSingleValue } from "../../TypesNEW";
import { isDefinedString, isPositiveNumber } from "et3-type-guards";
import { apiCallGetAllAdminAlkhattabat } from "../../api/khattbat-api/api-call-get-all-khattabat";
import getCorePopUpStore from "../core/core-popup-store";
import getCoreUIStore from "../core/core-ui-store";
import { DEFAULT_ET3_PICKER_SINGLE_VALUE } from "../../constants/picker-entries-constants";

class KhattabatReassignStore {
  alkhattabatList = observable.box<TEt3PickerSingleValue[]>([
    {
      label: "",
      value: ""
    }
  ]);

  oldKhatabaAdminId = observable.box<TEt3PickerSingleValue>({
    label: "",
    value: ""
  });
  newKhatabaAdminId = observable.box<TEt3PickerSingleValue>({
    label: "",
    value: ""
  });
  userIdToReassign = observable.box<number>(-1);

  typeToReassign = observable.box<TEt3PickerSingleValue>({
    label: "",
    value: ""
  });
  leavingArabicMessage = observable.box<string>("");
  leavingEnglishMessage = observable.box<string>("");
  leavingFrenshMessage = observable.box<string>("");
  leavingTurkishMessage = observable.box<string>("");
  leavingIndonesianMessage = observable.box<string>("");

  setLeavingArabicMessage = (message: string) => {
    runInAction(() => {
      this.leavingArabicMessage.set(message);
    });
  };
  setLeavingEnglishMessage = (message: string) => {
    runInAction(() => {
      this.leavingEnglishMessage.set(message);
    });
  };
  setLeavingFrenshMessage = (message: string) => {
    runInAction(() => {
      this.leavingFrenshMessage.set(message);
    });
  };
  setLeavingTurkishMessage = (message: string) => {
    runInAction(() => {
      this.leavingTurkishMessage.set(message);
    });
  };
  setLeavingIndonesianMessage = (message: string) => {
    runInAction(() => {
      this.leavingIndonesianMessage.set(message);
    });
  };
  setAlkhattabatList = async () => {
    const alkhattabatList = await apiCallGetAllAdminAlkhattabat();
    const alkhattabatListPicker = alkhattabatList.data.map((item) => {
      return {
        label: item.username,
        value: `${item.khattabatAdminId}`
      };
    });

    runInAction(() => {
      this.alkhattabatList.set(alkhattabatListPicker);
    });
  };
  setOldKhatabaAdminId = (admin: TEt3PickerSingleValue) => {
    runInAction(() => {
      this.oldKhatabaAdminId.set(admin);
    });
  };
  setNewKhatabaAdminId = (admin: TEt3PickerSingleValue) => {
    runInAction(() => {
      this.newKhatabaAdminId.set(admin);
    });
  };
  setUserIdToReassign = (id: number) => {
    runInAction(() => {
      this.userIdToReassign.set(id);
    });
  };
  setTypeToReassign = (type: TEt3PickerSingleValue) => {
    runInAction(() => {
      this.typeToReassign.set(type);
    });
  };
  submitReassign = async () => {
    const type = this.typeToReassign.get();
    const oldKhatabaAdminId = parseInt(this.oldKhatabaAdminId.get().value, 10);
    const newKhatabaAdminId = parseInt(this.newKhatabaAdminId.get().value, 10);
    if (
      !isPositiveNumber(oldKhatabaAdminId) ||
      !isPositiveNumber(newKhatabaAdminId)
    ) {
      getCorePopUpStore().showAlertMessage("INVALID_INPUT");
      getCoreUIStore().setIsLoading("DEVELOPER_REASSIGN_KHATTABA", false);
      return;
    }
    getCoreUIStore().setIsLoading("DEVELOPER_REASSIGN_KHATTABA", true);
    if (type.value === "all") {
      await this.submitReassignAll({
        oldKhatabaAdminId,
        newKhatabaAdminId
      });
    } else {
      await this.submitReassignOne({
        oldKhatabaAdminId,
        newKhatabaAdminId
      });
    }
    getCoreUIStore().setIsLoading("DEVELOPER_REASSIGN_KHATTABA", false);
    return;
  };
  submitReassignAll = async ({
    oldKhatabaAdminId,
    newKhatabaAdminId
  }: {
    oldKhatabaAdminId: number;
    newKhatabaAdminId: number;
  }) => {
    const { code, status } = await apiCallReassignKhattabaAll({
      oldAssignedAdminId: oldKhatabaAdminId,
      newAssignedAdminId: newKhatabaAdminId,
      leavingArabicMessage: this.leavingArabicMessage.get(),
      leavingEnglishMessage: this.leavingEnglishMessage.get(),
      leavingFrenshMessage: this.leavingFrenshMessage.get(),
      leavingTurkishMessage: this.leavingTurkishMessage.get(),
      leavingIndonesianMessage: this.leavingIndonesianMessage.get()
    });

    if (status === "ERROR") {
      getCorePopUpStore().showAlertMessage(code);
    } else {
      getCorePopUpStore().showSuccessMessage("REASSIGNMENT_IS_COMPLETED");
      this.clearDashboard();
    }
    return;
  };
  submitReassignOne = async ({
    oldKhatabaAdminId,
    newKhatabaAdminId
  }: {
    oldKhatabaAdminId: number;
    newKhatabaAdminId: number;
  }) => {
    if (this.userIdToReassign.get() === -1) {
      getCorePopUpStore().showAlertMessage("INVALID_INPUT");
      getCoreUIStore().setIsLoading("DEVELOPER_REASSIGN_KHATTABA", false);
      return;
    }
    const { status, code } = await apiCallReassignKhattabaOne({
      oldAssignedAdminId: oldKhatabaAdminId,
      newAssignedAdminId: newKhatabaAdminId,
      userIdToReassign: this.userIdToReassign.get(),
      leavingArabicMessage: this.leavingArabicMessage.get(),
      leavingEnglishMessage: this.leavingEnglishMessage.get(),
      leavingFrenshMessage: this.leavingFrenshMessage.get(),
      leavingTurkishMessage: this.leavingTurkishMessage.get(),
      leavingIndonesianMessage: this.leavingIndonesianMessage.get()
    });

    if (status === "ERROR") {
      getCorePopUpStore().showAlertMessage(code);
    } else {
      getCorePopUpStore().showSuccessMessage("REASSIGNMENT_IS_COMPLETED");
      this.clearDashboard();
    }
    return;
  };

  isReassignEnabled = computed(() => {
    if (
      !isDefinedString(this.typeToReassign.get().value) ||
      !isDefinedString(this.oldKhatabaAdminId.get().value) ||
      !isDefinedString(this.newKhatabaAdminId.get().value) ||
      !isDefinedString(this.leavingArabicMessage.get()) ||
      !isDefinedString(this.leavingEnglishMessage.get()) ||
      !isDefinedString(this.leavingFrenshMessage.get()) ||
      !isDefinedString(this.leavingTurkishMessage.get()) ||
      !isDefinedString(this.leavingIndonesianMessage.get())
    ) {
      return false;
    }
    const isByUserId = this.typeToReassign.get().value === "one";
    if (isByUserId && !isPositiveNumber(this.userIdToReassign.get())) {
      return false;
    }
    return true;
  });

  clearDashboard = () => {
    this.setOldKhatabaAdminId(DEFAULT_ET3_PICKER_SINGLE_VALUE);
    this.setNewKhatabaAdminId(DEFAULT_ET3_PICKER_SINGLE_VALUE);
    this.setTypeToReassign(DEFAULT_ET3_PICKER_SINGLE_VALUE);
    this.setUserIdToReassign(-1);
    this.setLeavingArabicMessage("");
    this.setLeavingEnglishMessage("");
    this.setLeavingFrenshMessage("");
    this.setLeavingTurkishMessage("");
    this.setLeavingIndonesianMessage("");
  };
}

export const getKhattabatReassignStore = memoize(
  () => {
    return new KhattabatReassignStore();
  },
  () => 1
);

export default getKhattabatReassignStore;
